var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-background",class:_vm.wrapperClass,style:({ 'background-image': 'url(' + _vm.Image + ')' })})}
var staticRenderFns = []

export { render, staticRenderFns }